var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 19.188c5.063 0 9.188-4.125 9.188-9.188 0-5.063-4.125-9.187-9.188-9.187C4.437.813.312 4.937.312 10s4.125 9.188 9.188 9.188Zm0-1.414A7.764 7.764 0 0 1 1.726 10 7.764 7.764 0 0 1 9.5 2.226 7.764 7.764 0 0 1 17.274 10 7.764 7.764 0 0 1 9.5 17.774Zm.707-2.827V7.88H8.793v7.067h1.414Zm0-8.48V5.052H8.793v1.413h1.414Z",
  fill: "#111"
})));
export default SvgInfo;